var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('div',{staticClass:"Login__icon"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Way"),_c('span',[_vm._v("Peak")])])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }